import { FillLayerSpecification, LineLayerSpecification } from "maplibre-gl";

const BRAND_PRIMARY_COLOR = "#0077CC";

export const postalCodePolygonLineLayer: LineLayerSpecification = {
	id: "postal-code-polygon-line-layer",
	type: "line",
	source: "postal-code-polygon-source",
	paint: {
		"line-color": BRAND_PRIMARY_COLOR,
		"line-width": 4,
	},
};

export const postalCodePolygonFillLayer: FillLayerSpecification = {
	id: "postal-code-polygon-fill-layer",
	type: "fill",
	source: "postal-code-polygon-source",
	paint: {
		"fill-color": BRAND_PRIMARY_COLOR,
		"fill-opacity": 0.15,
	},
};
